import { InboxAttachmentBase } from '@sb-tools/typescript/models/inbox-attachment-base.model';
import { MessageDTO } from '@sb-tools/typescript/models/dto/message.dto';

export class CustomerReplyPortalReplyModelBody {
    attachments: InboxAttachmentBase[] = [];
    message: MessageDTO = { text: null, html: null };
}
